"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformExpenseRequest = exports.transformExpenseListResponse = exports.transformExpenseResponse = exports.ExpenseStatus = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Money_1 = require("./Money");
const Error_1 = require("./Error");
const helpers_1 = require("./helpers");
const Date_1 = require("./Date");
const ExpenseCategory_1 = require("./ExpenseCategory");
var ExpenseStatus;
(function (ExpenseStatus) {
    ExpenseStatus[ExpenseStatus["internal"] = 0] = "internal";
    ExpenseStatus[ExpenseStatus["outstanding"] = 1] = "outstanding";
    ExpenseStatus[ExpenseStatus["invoiced"] = 2] = "invoiced";
    ExpenseStatus[ExpenseStatus["recouped"] = 3] = "recouped";
})(ExpenseStatus = exports.ExpenseStatus || (exports.ExpenseStatus = {}));
function transformExpenseResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { expense } = response.response.result;
    return transformExpenseParsedResponse(expense);
}
exports.transformExpenseResponse = transformExpenseResponse;
function transformExpenseListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { expenses, per_page, total, page, pages } = response.response.result;
    return {
        expenses: expenses.map((expense) => transformExpenseParsedResponse(expense)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformExpenseListResponse = transformExpenseListResponse;
function transformExpenseParsedResponse(expense) {
    return {
        categoryId: (0, helpers_1.transformIdResponse)(expense.categoryid),
        markupPercent: Number(expense.markup_percent),
        projectId: (0, helpers_1.transformIdResponse)(expense.projectid),
        clientId: (0, helpers_1.transformIdResponse)(expense.clientid),
        taxPercent1: expense.taxPercent1,
        taxName2: expense.taxName2,
        taxName1: expense.taxName1,
        isDuplicate: expense.isduplicate,
        profileId: (0, helpers_1.transformIdResponse)(expense.profileid),
        taxPercent2: expense.taxPercent2,
        accountName: expense.account_name,
        transactionId: (0, helpers_1.transformIdResponse)(expense.transactionid),
        invoiceId: (0, helpers_1.transformIdResponse)(expense.invoiceid),
        id: (0, helpers_1.transformIdResponse)(expense.id),
        taxAmount2: expense.taxAmount2 && (0, Money_1.transformMoneyParsedResponse)(expense.taxAmount2),
        taxAmount1: expense.taxAmount1 && (0, Money_1.transformMoneyParsedResponse)(expense.taxAmount1),
        visState: expense.vis_state,
        status: expense.status,
        bankName: expense.bank_name,
        updated: (0, Date_1.transformDateResponse)(expense.updated, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        vendor: expense.vendor,
        extSystemId: (0, helpers_1.transformIdResponse)(expense.ext_systemid),
        staffId: (0, helpers_1.transformIdResponse)(expense.staffid),
        date: (0, Date_1.transformDateResponse)(expense.date, Date_1.DateFormat['YYYY-MM-DD']),
        hasReceipt: expense.has_receipt,
        accountingSystemId: (0, helpers_1.transformIdResponse)(expense.accounting_systemid),
        notes: expense.notes,
        extInvoiceId: (0, helpers_1.transformIdResponse)(expense.ext_invoiceid),
        amount: (0, Money_1.transformMoneyParsedResponse)(expense.amount),
        expenseId: (0, helpers_1.transformIdResponse)(expense.expenseid),
        compoundedTax: expense.compounded_tax,
        accountId: (0, helpers_1.transformIdResponse)(expense.accountid),
        category: expense.category && (0, ExpenseCategory_1.transformExpenseCategoryParsedResponse)(expense.category),
    };
}
function transformExpenseRequest(expense) {
    return JSON.stringify({
        expense: {
            categoryid: expense.categoryId,
            markup_percent: expense.markupPercent,
            projectid: expense.projectId,
            clientid: expense.clientId,
            taxPercent1: expense.taxPercent1,
            taxName2: expense.taxName2,
            taxName1: expense.taxName1,
            isduplicate: expense.isDuplicate,
            profileid: expense.profileId,
            taxPercent2: expense.taxPercent2,
            account_name: expense.accountName,
            transactionid: expense.transactionId,
            invoiceid: expense.invoiceId,
            id: expense.id,
            taxAmount2: expense.taxAmount2 && (0, Money_1.transformMoneyParsedRequest)(expense.taxAmount2),
            taxAmount1: expense.taxAmount1 && (0, Money_1.transformMoneyParsedRequest)(expense.taxAmount1),
            vis_state: expense.visState,
            status: expense.status,
            bank_name: expense.bankName,
            vendor: expense.vendor,
            ext_systemid: expense.extSystemId,
            staffid: expense.staffId,
            date: (0, Date_1.transformDateRequest)(expense.date),
            has_receipt: expense.hasReceipt,
            notes: expense.notes,
            ext_invoiceid: expense.extInvoiceId,
            amount: expense.amount && (0, Money_1.transformMoneyParsedRequest)(expense.amount),
            expenseid: expense.expenseId,
            compounded_tax: expense.compoundedTax,
            accountid: expense.accountId,
        },
    });
}
exports.transformExpenseRequest = transformExpenseRequest;
//# sourceMappingURL=Expense.js.map